var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgMiddleRight = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1934 20.7689L19.1934 2.86389C19.1934 2.40458 19.5657 2.03223 20.025 2.03223C20.4843 2.03223 20.8567 2.40458 20.8567 2.86389L20.8567 20.7689C20.8567 21.2279 20.4841 21.6005 20.025 21.6005C19.5659 21.6005 19.1934 21.2279 19.1934 20.7689Z",
    fill: "#5C5F62"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8628 12.6027L3.29648 12.6027C2.79943 12.6027 2.39648 12.1998 2.39648 11.7027C2.39648 11.2057 2.79943 10.8027 3.29648 10.8027L13.8628 10.8027L13.8628 8.10273L17.4538 11.7027L13.8628 15.3027L13.8628 12.6027Z",
    fill: "#5C5F62"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMiddleRight, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/middle-right.3f44d969.svg";
export { ForwardRef as ReactComponent };